import { createFileRoute } from "@tanstack/react-router"
import { CreateAnnouncementPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/communication/announcements/new"
)({
  component: () => (
    <AuthorizationGate resource={Resource.ANNOUNCEMENT} action={Action.CREATE}>
      <CreateAnnouncementPage />
    </AuthorizationGate>
  ),
})
